"use client";

import { c as _c } from "react/compiler-runtime";
import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";
import { createContext, useContext, useMemo } from "react";
import { Check, CircleFilled } from "../../icons";
import { disabledVariants } from "../../styles";
import { classNames, tv } from "../../utils";
import { Media } from "../Media";
const RadioGroupContext = createContext({
  variant: "default"
});
function RadioGroup(t0) {
  const $ = _c(14);
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      variant: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
  }
  const variant = t1 === undefined ? "default" : t1;
  let t2;
  let t3;
  if ($[4] !== variant) {
    t3 = {
      variant
    };
    $[4] = variant;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  t2 = t3;
  const value = t2;
  let t4;
  if ($[6] !== className) {
    t4 = classNames("grid gap-4", className);
    $[6] = className;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== props || $[9] !== t4) {
    t5 = <RadioGroupPrimitive.Root className={t4} {...props} />;
    $[8] = props;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5 || $[12] !== value) {
    t6 = <RadioGroupContext.Provider value={value}>{t5}</RadioGroupContext.Provider>;
    $[11] = t5;
    $[12] = value;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}
const radioGroupItemVariants = tv({
  base: "rounded-full outline-hidden transition-colors",
  variants: {
    variant: {
      default: "size-6 min-h-[24px] min-w-[24px] border-2 data-[state=unchecked]:border-border-3 data-[state=unchecked]:focus:border-border-3",
      checkmark: "size-6 min-h-[24px] min-w-[24px] border border-border-1 bg-bg-additional-2 data-[state=checked]:bg-blue-3 md:size-7"
    }
  }
});
export function RadioGroupItem(t0) {
  const $ = _c(16);
  let className;
  let disabled;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      disabled,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = disabled;
    $[3] = props;
  } else {
    className = $[1];
    disabled = $[2];
    props = $[3];
  }
  const {
    variant
  } = useContext(RadioGroupContext);
  let t1;
  if ($[4] !== className || $[5] !== disabled || $[6] !== variant) {
    t1 = classNames(radioGroupItemVariants({
      variant
    }), disabledVariants({
      disabled
    }), className);
    $[4] = className;
    $[5] = disabled;
    $[6] = variant;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const t2 = "value" in props ? props.value : "";
  let t3;
  if ($[8] !== variant) {
    t3 = <RadioGroupPrimitive.Indicator className="fade-in flex animate-in items-center justify-center">{variant === "default" ? <CircleFilled size={12} /> : <><Media lessThan="md"><Check fill="white" size={20} /></Media><Media greaterThanOrEqual="md"><Check fill="white" size={24} /></Media></>}</RadioGroupPrimitive.Indicator>;
    $[8] = variant;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== disabled || $[11] !== props || $[12] !== t1 || $[13] !== t2 || $[14] !== t3) {
    t4 = <RadioGroupPrimitive.Item className={t1} disabled={disabled} value={t2} {...props}>{t3}</RadioGroupPrimitive.Item>;
    $[10] = disabled;
    $[11] = props;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
}

/**
 * Displays a list of radio toggles.
 */
export { RadioGroup };